import React from 'react';

const DENTModalOverviewViewOptionsIcon = () => {
	return (
		<svg
			width='20'
			height='20'
			fill='none'
			viewBox='0 0 20 20'
			stroke='currentColor'>
			<ellipse
				cx='10'
				cy='10'
				rx='7'
				ry='4'
				stroke='currentColor'
				strokeWidth='2'
				fill='none'
			/>
			<circle cx='10' cy='10' r='2' fill='currentColor' />
		</svg>
	);
};

export default DENTModalOverviewViewOptionsIcon;
